// custom functions
var FE = {
	location: window.location,

    Lightbox: {
      init: function () {
          $('.lightbox').magnificPopup({
              type:'image',
              gallery:{enabled:true}
          });
      }
    },

	MobileMenu: {
		init: function() {
            FE.MobileMenu.indicateSubMenu();
            $('.burger-icon').on('click', function () {
                $(this).toggleClass('active');
                //$('.nav-main > ul').slideToggle();
                $('.nav-main > ul').toggleClass('active');
            });
		},
        indicateSubMenu: function() {
            $('.nav-main > ul > li').each(function() {
                if ( $(this).find('ul').length ) {
                    $(this).prepend('<span>&gt;</span>');
                }
                $(this).find('span').click(function() {
                    $(this).toggleClass('open');
                    $(this).siblings('ul').slideToggle();
                });
            });
        }
	},

    HeaderShrink: {
        init: function () {
            window.addEventListener('scroll', function(e){
                var distanceY = window.pageYOffset || document.documentElement.scrollTop,
                    shrinkOn = 50;
                if (distanceY > shrinkOn) {
                    $('.header-main').addClass('compact');
                } else {
                    if ( $('.header-main').hasClass('compact') ) {
                        $('.header-main').removeClass('compact');
                    }
                }
            })
        }
    },

    HeaderSlider: {
        init: function() {
            $('.ce-hero-image').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: '.slider-for',
                dots: false,
                arrows: false,
                infinite: true,
                speed: 1000,
                fade: false,
                slide: 'figure',
                cssEase: 'linear',
                autoplay: true,
                autoplaySpeed: 5000,
                //lazyLoad: 'progressive',
                lazyLoad: 'ondemand',
                lazyLoadBuffer: 2,
                centerMode: false,
                focusOnSelect: false
            });
        }
    },

    TurncampsRegistrationPowermail: {
	    init: function () {
            FE.TurncampsRegistrationPowermail.campPreselect();
            FE.TurncampsRegistrationPowermail.checkWaitingList();
        },
	    campPreselect: function () {
            $('.powermail_fieldwrap_camp option').attr('disabled', 1);
            $('.page-id-470').find('.powermail_fieldwrap_camp option').eq(0)
                .prop('disabled', false)
                .prop('selected', true);
            $('.page-id-477').find('.powermail_fieldwrap_camp option').eq(1)
                .prop('disabled', false)
                .prop('selected', true);
            $('.page-id-478').find('.powermail_fieldwrap_camp option').eq(2)
                .prop('disabled', false)
                .prop('selected', true);
            $('.page-id-479').find('.powermail_fieldwrap_camp option').eq(3)
                .prop('disabled', false)
                .prop('selected', true);
            $('.page-id-480').find('.powermail_fieldwrap_camp option').eq(4)
                .prop('disabled', false)
                .prop('selected', true);
            $('.page-id-481').find('.powermail_fieldwrap_camp option').eq(5)
                .prop('disabled', false)
                .prop('selected', true);

            if ( $('#powermail_field_anmeldenummer').val() === '' ) {
                FE.TurncampsRegistrationPowermail.setBookingNummer();
            }
        },
        setBookingNummer: function () {
            $('.page-id-470').find('#powermail_field_anmeldenummer').val( 'O1-' + Math.floor(Date.now() / 1000) );
            $('.page-id-477').find('#powermail_field_anmeldenummer').val( 'O2-' + Math.floor(Date.now() / 1000) );
            $('.page-id-478').find('#powermail_field_anmeldenummer').val( 'S1-' + Math.floor(Date.now() / 1000) );
            $('.page-id-479').find('#powermail_field_anmeldenummer').val( 'S2-' + Math.floor(Date.now() / 1000) );
            $('.page-id-480').find('#powermail_field_anmeldenummer').val( 'S3-' + Math.floor(Date.now() / 1000) );
            $('.page-id-481').find('#powermail_field_anmeldenummer').val( 'S4-' + Math.floor(Date.now() / 1000) );
        },
        checkWaitingList: function () {
            if ( $('body').hasClass('page-layout-2') ) {
                $('#powermail_field_warteliste_1').prop('checked', true);
            }
        }
    },

    TurncampRegistration: {
        init: function () {
            const bookingNumberField = document.querySelector('input[placeholder="Buchungsnummer"]');
            const bookingNumber = this.getBookingNumber();
            if ( bookingNumberField.value === '' ) {
                bookingNumberField.value = bookingNumber;
            }
        },
        getBookingNumber: function () {
            const urlPath = window.location.pathname.replace('.html', '');
            const urlParts = urlPath.split('/');
            const campNameUrlSegment = urlParts.pop();
            const campLetter = campNameUrlSegment.slice(0, 1);
            const campNumber = campNameUrlSegment.slice(-1);
            const campAbbr = campLetter.toUpperCase() + campNumber;
            const bookingNumber = campAbbr + '-' + Math.floor(Date.now() / 1000);
            return bookingNumber;
        },
    }

};

// init custom functions
(function ($, window, document, undefined) {

	$(function () {
	    FE.Lightbox.init();
		FE.MobileMenu.init();
		FE.HeaderShrink.init();
        if ( $('.ce-hero-image figure').length > 1 ) {
            FE.HeaderSlider.init();
        }
        if ( $('.powermail_fieldwrap_camp').length ) {
            FE.TurncampsRegistrationPowermail.init();
        }
        if (document.querySelector('.tx-sf-event-mgt form.registration')) {
            FE.TurncampRegistration.init();
        }
	});

}(jQuery, window, document));
